import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';


import { HttpClient } from '@angular/common/http';
import { Event } from '../interfaces';

@Injectable()
export class EventsService {

  constructor(private http: HttpClient) {
  }

  getAll(page?: number): Observable<any> {
    let queryParams = '';
    if (page) { queryParams += '?page=' + page; }
    return this.http.get<any[]>(
      environment.baseUrlWs + environment.wsVerison + 'employer/events/' + queryParams
    );
  }

  search(position?: string): Observable<any> {
    let queryParams = '';
    if (position) { queryParams += '?position=' + position; }
    return this.http.get<any[]>(
      environment.baseUrlWs + environment.wsVerison + 'employer/events/' + queryParams
    );
  }

  getById(id: number): Observable<Event> {
    return this.http.get<Event>(
      environment.baseUrlWs + environment.wsVerison + 'employer/events/' + id
    );
  }

  update(event: Event, eventForm: any): Observable<any> {
    return this.http.put(environment.baseUrlWs + environment.wsVerison + 'employer/events/' + event.id, eventForm)
  }

  create(jobOffer: Event, jobForm: any): Observable<any> {
    return this.http.post(environment.baseUrlWs + environment.wsVerison + 'employer/events/', jobForm, {})
  }

  getCheckIns(events_id: number): Observable<Array<Event>> {
    return this.http.get<Array<Event>>(
      environment.baseUrlWs + environment.wsVerison + 'employer/events/' + events_id + '/check-ins'
    );
  }

  // postCheckIns(id: number, page?: number, size?: number, body = {}): Observable<any> {
  postCheckIns(id: number, body = {}): Observable<any> {
    // body
    return this.http.post(
      environment.baseUrlWs + environment.wsVerison + 'employer/events/' + id + '/check-ins',
      body
    ) as Observable<any>;
  }

  getCheckinsFilters(id: number): Observable<any> {
    const url = `${environment.baseUrlWs}${environment.wsVerison}employer/events/${id}/check-ins/filters`;
    return this.http.get(url) as Observable<any>;
  }

  deleteEvent(id: number) {
    return this.http.delete(environment.baseUrlWs + environment.wsVerison + 'employer/events/' + id);
  }

  downloadEventCV(events_id: number, users_id: number) {
    const options = { responseType: 'blob' as 'json' };
    return this.http.get<Blob>(
      environment.baseUrlWs + environment.wsVerison + 'employer/events/' + events_id + '/cvs/' + users_id,
      options
    );
  }

  downloadAllEventCV(events_id: number) {
    const options = { responseType: 'blob' as 'json' };
    return this.http.get<Blob>(
      environment.baseUrlWs + environment.wsVerison + 'employer/events/' + events_id + '/all',
      options
    );
  }

}
